import {
  Box, Button, DashboardModule, FormField,
} from '@domain-group/suit-theme'

import useEntityImpersonation from '@hooks/useEntityImpersonation'

const ImpersonateUser = () => {
  const entityImpersonationPayload = useEntityImpersonation()
  const {
    callbacks: {
      impersonateUserWithToken,
      setState,
    },
    supportToken,
  } = entityImpersonationPayload

  return (
    <DashboardModule title="Login as User">
      <Box flexDirection="column" padding="large">
        <FormField label="Support Code">
          <Box>
            <input onChange={e => setState({ supportToken: e.target.value })} type="text" value={supportToken} />

            <Button
              buttonStyle="primaryEdit"
              disabled={supportToken.length < 6}
              marginLeft="medium"
              onClick={() => impersonateUserWithToken()}
              size="medium"
              width="auto"
            >
              Login
            </Button>
          </Box>
        </FormField>
      </Box>
    </DashboardModule>
  )
}

export default ImpersonateUser
